import { LeadActivity } from "views/leads-id/types";
import { combinedRoles } from "shared/app/ActivityLog/constants";

interface IdentityVerificationDataEditedItemProps {
  activity: LeadActivity;
}

export const IdentityVerificationDataEditedItem = ({
  activity
}: IdentityVerificationDataEditedItemProps) => {
  const changes =
    typeof activity.metadata === "object" && "changes" in activity.metadata
      ? (activity.metadata.changes as Record<
          string,
          { old: string; new: string }
        >)
      : null;

  return (
    <div className="space-y-1">
      <p className="text-content-400 text-sm">
        by {activity.actor?.name}
        {activity.actor?.role && (
          <> ({combinedRoles[activity.actor.role] || activity.actor.role})</>
        )}
      </p>
      {changes && (
        <div className="space-y-0.5">
          {Object.entries(changes).map(([field, change]) => {
            if (
              typeof change !== "object" ||
              !("old" in change) ||
              !("new" in change)
            )
              return null;

            const { old, new: newValue } = change;

            if (old === newValue && field !== "ssn") return null;

            return field === "ssn" ? (
              <p key={field} className="text-sm text-content-400">
                SSN was updated
              </p>
            ) : (
              <p key={field} className="text-sm text-content-400">
                Previous {field.replace(/_/g, " ")}: {old || "—"} • New{" "}
                {field.replace(/_/g, " ")}: {newValue || "—"}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};
